import { useState } from "react";
import { CheckCircle2, CircleDashed, XCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { http, errorMessage } from "../../lib/api";

const OPEN = [
  "Rechtsform und rechtliche Firmierung bestätigen; Impressum und Datenschutz (Verantwortlicher) entsprechend ergänzen.",
  "Bestätigen, ob Remzi Velila als Inhaber bzw. vertretungsberechtigte Person im Impressum genannt wird; ggf. Registergericht/-nummer und USt-IdNr. ergänzen, sofern vorhanden.",
  "Angabe „Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV“ prüfen.",
  "Rechtliche Prüfung der Auslandsvermittlung (u. a. § 292 SGB III / Beschäftigungsverordnung, bei Gesundheitsberufen WHO-Liste der Anwerbeländer) und ggf. erforderliche Gewerbeanmeldung.",
  "Auftragsverarbeitungsverträge mit Hosting (Emergent), E-Mail-Versand (Resend) und Odoo abschließen; Serverstandorte und Drittlandgarantien eintragen.",
  "Löschfristen für Arbeitgeberanfragen und Bewerberdaten festlegen; Talentpool-Dauer (24 Monate) bestätigen.",
  "Verfahren zur Weitergabe von Bewerberprofilen an Arbeitgeber festlegen.",
  "Prüfhinweise in der Datenschutzerklärung abarbeiten und entfernen; juristische Prüfung von Impressum und Datenschutz.",
  "Odoo-Zugang bereitstellen (URL, Datenbank, API-Benutzer, API-Schlüssel), Version und Rechte prüfen, Schnittstelle testen und erst dann aktivieren.",
  "Weitere Teamkonten anlegen und das Start-Passwort ändern.",
  "Domain pactora-personal.de mit der Website verbinden und PUBLIC_SITE_URL / CORS auf die Domain umstellen.",
  "Zustellung der Team-Benachrichtigung an info@pactora-personal.de im Postfach bestätigen.",
  "Englische Fassung der Datenschutzinformationen für Bewerber prüfen lassen und bereitstellen (englische Seiten verlinken derzeit die deutsche Fassung).",
];

const Dot = ({ ok }) => (ok === true ? <CheckCircle2 size={18} className="text-emerald-600" /> : ok === false ? <XCircle size={18} className="text-red-600" /> : <CircleDashed size={18} className="text-amber-600" />);

export const SystemPanel = ({ sys }) => {
  const [test, setTest] = useState(null);
  const [busy, setBusy] = useState(false);
  const runTest = async () => {
    setBusy(true);
    try { const { data } = await http.post("/admin-system/odoo/test"); setTest(data); toast.success("Odoo-Verbindung erfolgreich"); }
    catch (e) { toast.error(errorMessage(e)); }
    finally { setBusy(false); }
  };
  return (
    <div className="grid gap-6 lg:grid-cols-2" data-testid="system-panel">
      <section className="rounded-2xl border border-slate-200 bg-white p-6">
        <h2 className="font-bold text-[color:var(--navy)]">Systemstatus</h2>
        <ul className="mt-4 space-y-3 text-sm">
          <li className="flex gap-3"><Dot ok={sys?.storage} /> Privater Dokumentenspeicher {sys?.storage ? "erreichbar" : "nicht erreichbar"}</li>
          <li className="flex gap-3" data-testid="system-email-status">
            <Dot ok={sys?.email?.last_status === "gesendet" ? true : sys?.email?.last_status === "fehlgeschlagen" ? false : undefined} />
            <span>Team-Benachrichtigung an {sys?.email?.recipient ?? "–"} – letzte Zustellung: {sys?.email?.last_status ?? "noch keine"}{sys?.email?.last_error ? ` (${sys.email.last_error})` : ""}</span>
          </li>
          <li className="flex gap-3"><Dot ok={sys?.odoo?.configured ? true : undefined} /> Odoo: {sys?.odoo?.configured ? `konfiguriert (${sys.odoo.url}, automatische Übertragung ${sys.odoo.auto_sync ? "an" : "aus"})` : "nicht konfiguriert – Eingänge werden hier gespeichert und können exportiert werden"}</li>
          <li className="flex gap-3"><Dot /> Website-Adresse für Links: {sys?.site_url ?? "–"}</li>
        </ul>
        <button onClick={runTest} disabled={!sys?.odoo?.configured || busy} className="mt-6 inline-flex items-center gap-2 rounded-full border border-slate-300 px-4 py-2 text-sm font-semibold disabled:opacity-50" data-testid="system-odoo-test">
          {busy && <Loader2 size={15} className="animate-spin" />} Odoo-Verbindung testen
        </button>
        {test && <pre className="mt-4 overflow-x-auto rounded-xl bg-slate-50 p-3 text-xs">{JSON.stringify(test, null, 2)}</pre>}
      </section>
      <section className="rounded-2xl border border-amber-200 bg-amber-50/50 p-6" data-testid="prelaunch-checklist">
        <h2 className="font-bold text-[color:var(--navy)]">Interne Checkliste vor Veröffentlichung</h2>
        <ol className="mt-4 list-decimal space-y-2.5 pl-5 text-sm text-slate-800">
          {OPEN.map((o) => <li key={o}>{o}</li>)}
        </ol>
      </section>
    </div>
  );
};
